export const REARME_MS = 2000;
export const DURACION_RESULTADO_MS = 5000;

/**
 * Control de lecturas de cámara.
 * - El mismo QR sólo se vuelve a procesar tras `rearmeMs` sin detectarlo
 *   (cada detección renueva la ventana; una pérdida breve no lo rearma).
 * - Un QR distinto se procesa de inmediato.
 * - `puedeMostrar` evita que una respuesta tardía reemplace a una posterior.
 */
export const crearControlEscaneo = ({ rearmeMs = REARME_MS, ahora = () => Date.now() } = {}) => {
  let ultimo = null;
  let vistoEn = -Infinity;
  let seq = 0;
  let mostrado = 0;
  return {
    lectura(token) {
      const t = ahora();
      const repetido = token === ultimo && t - vistoEn < rearmeMs;
      vistoEn = t;
      if (repetido) return null;
      ultimo = token;
      seq += 1;
      return seq;
    },
    nuevaSolicitud() {
      seq += 1;
      return seq;
    },
    puedeMostrar(id) {
      if (id < mostrado) return false;
      mostrado = id;
      return true;
    },
  };
};
